import { render, staticRenderFns } from "./ClusterStatisticsPanel.vue?vue&type=template&id=063b6a46&scoped=true"
import script from "./ClusterStatisticsPanel.vue?vue&type=script&lang=js"
export * from "./ClusterStatisticsPanel.vue?vue&type=script&lang=js"
import style0 from "./ClusterStatisticsPanel.vue?vue&type=style&index=0&id=063b6a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b6a46",
  null
  
)

export default component.exports